// frontend/src/screens/EditProjectScreen.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjectDetails, updateProject } from "../actions/projectActions";
import { PROJECT_UPDATE_RESET } from "../constants/projectConstants";
// optionally PROJECT_DETAILS_RESET if you want
// import { PROJECT_DETAILS_RESET } from "../constants/projectConstants";

const EditProjectScreen = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  // projectDetails slice
  const projectDetails = useSelector((state) => state.projectDetails);
  const {
    loading: detailsLoading,
    error: detailsError,
    project,
  } = projectDetails;

  // projectUpdate slice
  const projectUpdate = useSelector((state) => state.projectUpdate);
  const {
    loading: updateLoading,
    error: updateError,
    projectUpdateSuccess,
  } = projectUpdate;

  useEffect(() => {
    // If we haven't loaded the correct project or none
    if (!project || project._id !== projectId) {
      dispatch(fetchProjectDetails(projectId));
    } else {
      setName(project.name || "");
      setDescription(project.description || "");
    }
  }, [dispatch, project, projectId]);

  // On success
  useEffect(() => {
    if (projectUpdateSuccess) {
      // navigate away
      navigate("/admin-dashboard");
      // reset leftover success
      dispatch({ type: PROJECT_UPDATE_RESET });
      // optional reset project details
      // dispatch({ type: PROJECT_DETAILS_RESET });
    }
  }, [projectUpdateSuccess, dispatch, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      updateProject(projectId, {
        name,
        description,
      })
    );
  };

  return (
    <div>
      <h2>Edit Project (ID: {projectId})</h2>
      {detailsError && <p style={{ color: "red" }}>{detailsError}</p>}
      {updateError && <p style={{ color: "red" }}>{updateError}</p>}
      {(detailsLoading || updateLoading) && <p>Loading...</p>}

      <form onSubmit={handleSubmit}>
        <div>
          <label>Project Name:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div>
          <label>Description:</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <button type="submit">Update Project</button>
      </form>
    </div>
  );
};

export default EditProjectScreen;
